import { Skeleton } from '@repo/ui/src/components/ui/skeleton';

/**
 * The loading block every list/table shows while its first page is in flight:
 * the shape of the rows, not the word "Đang tải...". Mirrors the invoice
 * list's inline skeleton (InvoicesPage) so every list loads the same way.
 * `label` is the sr-only text for screen readers (usually the namespace's
 * `list.loading`).
 */
export function ListSkeleton({ rows = 3, label, dense = false }: { rows?: number; label: string; dense?: boolean }) {
  return (
    <div className="divide-y divide-surface-200" aria-busy="true">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={dense ? 'flex items-center gap-3 px-3 py-3' : 'flex items-center gap-3 px-4 py-4'}>
          <Skeleton className="h-4 w-4 shrink-0" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="ml-auto h-5 w-16 rounded-full" />
          <Skeleton className="h-4 w-24" />
        </div>
      ))}
    </div>
  );
}
